import React from "react";

export function SyncErrorConfirmationText() {
    return <div>Ошибка синхронизации данных. Рекомендуется обновить страницу.</div>;
}
